module.exports = __webpack_public_path__ + "static/media/fooderloo_logo_horizontal.f0964f93.png";